import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withKeys as _withKeys, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4909631a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ml-8 text-lg" }

import { onMounted, onUnmounted, ref, watch } from "vue";

	
export default /*#__PURE__*/_defineComponent({
  __name: 'WaitingLoader',
  props: {
		name: {
			type: String,
			default: "modal",
		},
		msg: {
			type: String,
			default: "Modal Title",
		},
		defaultStyle: {
			type: Boolean,
			default: true,
		},
		enableLoader: {
			type: Boolean,
			default: true,
		},
	},
  emits: ["close", "mounted"],
  setup(__props, { emit: __emit }) {

	const emit = __emit;

	const typeAnimate = ref("animate__zoomIn");
	const props = __props;

	/**
	 * Varialbles
	 */

	// Stream surface View
	let modalView: any;

	function setModalView() {
		if (!modalView) {
			modalView = document.querySelector("#modalpage");
			// console.log("modalView open: ", modalView);
			document.body.appendChild(modalView);
		}
	}

	function closeModalView() {
		typeAnimate.value = "animate__zoomOutLeft";

		if (modalView) {
			// document.body.removeChild(modalView);
			modalView.style.display = "none";
			modalView.style.animation = "zoomOut";
			modalView = null;
		}
		emit("close", props.name);
	}

	onMounted(() => {
		setModalView();
		emit("mounted", props.name);
	});

	onUnmounted(() => {
		closeModalView();
	});

return (_ctx: any,_cache: any) => {
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock("div", {
    onKeydown: _withKeys(closeModalView, ["esc"]),
    id: "modalpage",
    class: "fixed top-0 bottom-0 left-0 right-0 flex flex-col items-center justify-center transition-all duration-100 ease-linear app-modal"
  }, [
    _createElementVNode("div", {
      id: "animate",
      class: _normalizeClass([
				typeAnimate.value,
				{
					'flex p-8 w-2/4 justify-center items-center transition-all duration-100 ease-linear animate__animated  animate__faster_xx': __props.defaultStyle,
				},
			])
    }, [
      (__props.enableLoader)
        ? (_openBlock(), _createBlock(_component_Spinner, {
            key: 0,
            width_: "10px",
            height_: "30px",
            width: "1px",
            height: "20px",
            color: "#219152"
          }))
        : _createCommentVNode("", true),
      _createElementVNode("p", _hoisted_1, _toDisplayString(__props.msg), 1)
    ], 2)
  ], 32))
}
}

})